<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <sdCards headless>
        <a-form
          layout="horizontal"
          :model="formState"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
          :rules="rules"
          @finish="handleSubmit"
        >
          <a-form-item name="name" label="Nama">
            <a-input v-model:value="formState.name" placeholder="Masukkan Nama" />
          </a-form-item>
          <a-form-item name="permissions" label="Permission">
            <a-select
              placeholder="Pilih Permission"
              v-model:value="formState.permissions"
              show-search
              :filter-option="filterSelect"
              mode="multiple"
            >
              <a-select-option v-for="option in options.permission" :key="option.value">
                {{ option.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-row>
            <a-col :lg="{ span: 18, offset: 6 }" :md="{ span: 15, offset: 9 }" :xs="{ span: 24, offset: 0 }">
              <div class="sDash_form-action">
                <sdButton class="sDash_form-action__btn" type="primary" size="large" htmlType="submit">
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>

                <router-link to="/masters/role">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </sdCards>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../components/crud/style';
import { Main } from '../../styled';
import { useStore } from 'vuex';
import { reactive, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const RoleForm = {
  name: 'RoleForm',
  components: { HorizontalFormStyleWrap, Main },
  data() {
    return {
      title: this.mode + ' ' + this.module,
    };
  },
  props: ['mode', 'module'],
  setup(props) {
    const { state, dispatch } = useStore();
    const { params } = useRoute();
    const isLoading = computed(() => state.crud.loading);
    const crud = computed(() => state.crud.data);

    const formState = reactive({
      name: '',
      permissions: [],
    });

    const labelCol = {
      lg: 6,
      md: 9,
      xs: 24,
    };

    const wrapperCol = {
      lg: 18,
      md: 15,
      xs: 24,
    };

    const options = reactive({
      permission: [],
    });

    const handleSubmit = values => {
      if (props.mode == 'Tambah') {
        dispatch('axiosCrudSubmitData', {
          url: 'role',
          data: values,
        });
      } else if (props.mode == 'Ubah') {
        dispatch('axiosDataUpdate', {
          id: params.id,
          url: 'role',
          data: values,
        });
      }
    };

    const rules = {
      name: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
    };

    onMounted(() => {
      dispatch('axiosCrudGetData', 'options-permission').then(() => {
        options.permission = crud.value;
      });

      if (props.mode == 'Ubah') {
        const data = {
          url: 'role',
          id: params.id,
        };

        dispatch('axiosSingleDataGet', data).then(() => {
          Object.keys(crud.value).forEach(key => {
            if (key == 'permissions') {
              for (let ii = 0; ii < crud.value[key].length; ii++) {
                formState[key].push(crud.value[key][ii].id);
              }
            } else formState[key] = crud.value[key];
          });

          console.log(formState);
        });
      }
    });

    const filterSelect = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    return {
      formState,
      labelCol,
      wrapperCol,
      handleSubmit,
      isLoading,
      rules,
      options,
      filterSelect,
    };
  },
};

export default RoleForm;
</script>
